jQuery(document).ready(function ($) {
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 80) {
            $("nav.navbar").addClass("fixed");
        } else {
            $("nav.navbar").removeClass("fixed");
        }
    });
});
